export const STEP_1 = 1;
export const STEP_2 = 2;
//# sourceMappingURL=constants.js.map